import { render, staticRenderFns } from "./InclusionRisk.vue?vue&type=template&id=343fc6bc&scoped=true&"
import script from "./InclusionRisk.vue?vue&type=script&lang=js&"
export * from "./InclusionRisk.vue?vue&type=script&lang=js&"
import style0 from "./InclusionRisk.vue?vue&type=style&index=0&id=343fc6bc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343fc6bc",
  null
  
)

export default component.exports